module.exports = __webpack_public_path__ + "static/genio-screenshots-9adf2643fa406b326cc08f54ebbb99d5.png";